import { ADD, UPDATE } from "./actions";


export const initialStatus = {
    update: false
}

const toogleReducer = (state = initialStatus, action) =>{
    switch (action.type) {
        case UPDATE:
            return{
                ...state,
                update: true,
                id: action.payload
            }
        case ADD:
            return{
                ...state,
                update: false,
                id: undefined,
            }
    
        default:
            return state;
    }
}

export default toogleReducer;